interface InstantEstimateSectionProps {
  title?: string;
  subtitle?: string;
  className?: string;
}

export const InstantEstimateSection = ({
  title = "Get an Instant Estimate",
  subtitle = "Use our instant estimator to get a ballpark price for your roof replacement in seconds — no phone call required.",
  className = "",
}: InstantEstimateSectionProps) => {
  return (
    <section className={`py-16 lg:py-24 bg-muted/30 ${className}`} aria-labelledby="instant-estimate-heading">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-8">
          <h2
            id="instant-estimate-heading"
            className="text-3xl md:text-4xl font-heading font-bold text-foreground mb-4"
          >
            {title}
          </h2>
          <p className="text-lg text-muted-foreground">{subtitle}</p>
        </div>
        <div className="flex justify-center">
          <iframe
            src="https://app.roofmammoth.ai/embed/516d5160-0155-4b46-814b-5f3ab1c12a0f"
            width="100%"
            height="800"
            style={{ border: "none", maxWidth: "600px" }}
            title="Roof Replacement Instant Estimate"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};
